import React, { Suspense, useEffect, useState } from "react";
import io from 'socket.io-client';
import Spinner from "../../../../views/spinner/Spinner";

// Socket.IO sunucu URL'si
//export const socket = io('http://localhost:4000');



const Loadable = (Component) => (props) =>{
  console.log(window.location.href);
  return(
    <Suspense fallback={<Spinner location={window.location.pathname}/>}>
      <Component {...props} />
    </Suspense>
  );
}
export default Loadable;
